import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
const SET_ERROR = 'SET_ERROR';
const RESET_ERROR = 'RESET_ERROR';

const initialState = {
  display: false,
  type: '',
};

// ------------------------------------
// Actions
// ------------------------------------
function setError(type = '') {
  return {
    type: SET_ERROR,
    payload: type
  }
}

function resetError(){
  return {
    type: RESET_ERROR
  }
}

export {
  setError,
  resetError
};


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SET_ERROR]: (state, action) => ({
    display: true,
    type: action.payload
  }),
  [RESET_ERROR]: () => initialState
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function errorReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}




// WEBPACK FOOTER //
// ./src/components/shared/ErrorOverlay/modules/error.js